import React from "react";
import "./alertSection.scss";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

interface AlertSectionInterface {
  alert: any;
}

const alertSection = (props: AlertSectionInterface) => {
  const { alert } = props;
  console.log("alert", alert);
  return (
    <div className="a-alertContainer">
      <span className="icon-exclamation-triangle icon" />
      {/*<p className="a-alertContainer-text">{text}</p>*/}
      {documentToReactComponents(alert)}
    </div>
  );
};

export default alertSection;
